export const SOCIALS_GET = 'socialsGet'
export const BS_SOCIALS_GET = 'bsSocialsGet'
export const SOCIAL_CREATE = 'socialCreate'
export const SOCIAL_EDIT = 'socialEdit'
export const SOCIAL_DELETE = 'socialDelete'